import { styled } from '@mui/material'
import { Search } from '@mui/icons-material'

export const Link = styled('a')`
  align-items: center;
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  display: flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  justify-content: end;
  line-height: 18px;
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const Root = styled('div')`
  box-sizing: border-box;
  border: 1px solid ${props => props.theme.palette.gray[85]};
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 20px;

  ${props => props.theme.breakpoints.up('md')} {
    margin-left: 32px;
  }

  ${props => props.theme.breakpoints.between('xs', 'md')} {
    margin-top: 21px;
    margin-top: 26px;
  }
`

export const SearchIcon = styled(Search)`
  flex-shrink: 0;
  height: 20px;
  margin-right: 5px;
  width: 20px;
`
